import styled from 'styled-components';
// Material UI
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningOutlinedIcon from '@mui/icons-material/WarningOutlined';
import BMapsTooltip from 'BMapsUI/BMapsTooltip';

export default function TooltipInfo({ fontSize='smaller', warning, ...rest }) {
    return (
        <BMapsTooltip
            tabIndex="0"
            focusable
            fontSize={fontSize}
            {...rest}
        >
            {warning ? <WarningOutlinedIcon /> : <InfoOutlinedIcon />}
        </BMapsTooltip>
    );
}
